<template>
  <div v-loading="loading">
    <div>
      <div v-if="multiple" style="display: flex">
        <el-upload ref="uploadFile" :action="url" :auto-upload="false" @uploading="showloading"
                   :on-change="getFileList" multiple :show-file-list="false" :accept="accept" :path="path">
          <el-button :size="size" type="primary" plain>{{ btnContent }}</el-button>
        </el-upload>
        <el-button @click="uploadFile" style="margin-left:10px" type="success" plain>上传</el-button>
      </div>
      <el-upload v-else :class="iconBtn?'avatar-uploader':'upload-demo'" @uploading="showloading" :on-change="upldchange" ref="uploadFile" :action="url" :show-file-list="false" :accept="accept" :path="path" :auto-upload="false">
        <el-button :size="size" type="primary" plain>{{ btnContent }}</el-button>
      </el-upload>
    </div>
    <div style="display: flex;flex-wrap: wrap;">
      <div v-for="(item,index) in fileList" :key="index" style="border: 1px solid #E5E5E5;border-radius: 5px;margin:5px;display: flex;align-items: center;padding:5px">
        <div style="margin-right:5px">{{item.name}}</div>
        <div style="cursor: pointer" @click="deletePic(index)"><el-icon><delete/></el-icon></div>
      </div>
    </div>
  </div>
</template>
<script>
import {OSS, progress} from "./oss";

export default {
  name: "",
  data() {
    return {
      url: "",
      client: "",
      ossConfig: "",
      ossEndpoint: "",
      fileName: '',
      fileList: [],
      btnContent:'',
      loading:false
    };
  },
  props: {
    accept: {
      type: String,
    },
    path: {
      type: String,
      default: "upload",
    },
    iconBtn: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: "选择文件",
    },
    size: {
      type: String,
      default: "default",
    },
    hasDate: {
      type: Boolean,
      default: false
    },
    btnWidth: {
      type: String,
      default: "100px",
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.btnContent = (this.multiple?'选择':'上传')+this.btnText
  },
  methods: {
    showloading() {
      this.loading = true
    },
    hideloading() {
      this.loading=false
    },
    getFileList(file) {
      this.fileList.push(file)
    },
    deletePic(index){
      this.fileList.splice(index,1);
    },
    async uploadFile() {
      for (let item in this.fileList) {
        await this.upldchange(this.fileList[item])
      }
      this.fileList = [];
    },
    getFileName() {
      let date = new Date();
      this.fileName = this.path + '/';
      if (this.hasDate) {
        this.fileName += String(date.getFullYear()) + String((date.getMonth() + 1)).padStart(2, '0') + String(date.getDate()).padStart(2, '0') + '/';
      }
      let a = parseInt(Math.random() * 1000)
      this.fileName += date.getTime() + a.toString().padStart(4, '0');
    },
    initClient() {
      return new Promise(async (resolve, reject) => {
        let temp = sessionStorage.getItem("ossConfig");
        temp = JSON.parse(temp);
        let time = new Date().getTime();
        time = parseInt(time / 1000);
        if (temp && temp.time > time) {
          this.ossConfig = temp;
        }
        if (this.ossConfig === "") {
          await this.getOssConfig();
          sessionStorage.setItem("ossConfig", JSON.stringify(this.ossConfig));
        }
        this.ossEndpoint = this.ossConfig.endpoint;
        resolve(new OSS(this.ossConfig));
      });
    },
    getOssConfig(){
      return new Promise(resolve=>{
        this.$axios({
          url:this.HOST+'/admin.index/getOssconfig',
          method:'post'
        }).then((res) => {
          if(res.data.status === 1){
            this.ossConfig = res.data.ossConfig;
            resolve();
          }
        })
      })
    },
    upldchange(file) {
      return new Promise(async resolve => {
        this.showloading();
        this.getFileName()
        if (this.calcFileSize(file.raw.size) > 20) {
          this.$message({
            type: 'error',
            message: '不能上传超过20M的文件'
          })
        } else {
          this.showloading();
          await this.ossput(file.raw);
        }
        // if (this.calcFileSize(file.raw.size) > 100) {
        //   console.log("大文件 分片上传");
        //   await this.multipartUpload(file.raw);
        // } else {
        //   await this.ossput(file.raw);
        // }
        resolve()
      })
    },
    calcFileSize(byte) {
      return Math.ceil(byte / 1024 / 1024);
    },
    ossput(file) {
      // 获取文件后缀名，如'.jpg'
      return new Promise(async resolve => {
        let index = file.name.lastIndexOf(".");
        let type = file.name.slice(index);
        this.client = await this.initClient();
        this.$emit("uploading");
        let fileUrl = this.fileName + type;
        this.client
            .put(fileUrl, file)
            .then((res) => {
              this.hideloading();
              this.$emit("uploaded");
              this.$refs.uploadFile.clearFiles;
              if (res.res.statusCode === 200) {
                this.$emit("success", {
                  fileUrl: fileUrl,
                  path: this.path,
                  host:this.ossConfig.url,
                  name:file.name
                });
                // this.$message.success("上传成功！");
                resolve()
              } else {
                this.$message.error("上传失败！");
                // this.$emit("delete");
              }
            })
            .catch((err) => {
              console.log(err)
              this.hideloading();
              this.$message.error("上传失败请重试！");
              // this.$emit('uploaded');
              // console.log("上传失败：error", err);
            });
      })
    },
    // 分片上传
    multipartUpload(file) {
      return new Promise(async resolve => {
        let fileUrl = this.fileName + type
        this.$emit("uploading");
        this.client = await this.initClient();
        try {
          // 依次填写Object完整路径（例如exampledir/exampleobject.txt）和本地文件的完整路径（例如D:\\localpath\\examplefile.txt）。Object完整路径中不能包含Bucket名称。
          // 如果本地文件的完整路径中未指定本地路径（例如examplefile.txt），则默认从示例程序所属项目对应本地路径中上传文件。
          const result = await this.client.multipartUpload(
              fileUrl,
              file,
              {
                progress,
                // headers,
                // 指定meta参数，自定义Object的元信息。通过head接口可以获取到Object的meta数据。
                // meta: {
                //   year: 2020,
                //   people: 'test',
                // },
              }
          );
          // 填写Object完整路径，例如exampledir/exampleobject.txt。Object完整路径中不能包含Bucket名称。
          const head = await this.client.head(fileUrl);
          if (head.res.statusCode == 200) {
            this.hideloading();
            this.$emit("uploaded");
            // let fileUrl = head.res.requestUrls[0];
            this.$emit("success", {
              fileUrl: fileUrl,
              name: result.name,
              path: this.path,
            });
            this.$message.success("上传成功！");
          }
        } catch (e) {
          this.hideloading();
          this.$emit("uploaded");
          // 捕获超时异常。
          if (e.code === "ConnectionTimeoutError") {
            console.log("TimeoutError");
            // do ConnectionTimeoutError operation
          }
          console.log(e);
        }
        resolve()
      })
    },
  },
};
</script>